<template>
  <div v-if="error === ''">
    <gg-card-title>
      Promo Request #{{ promoRequestId }}
    </gg-card-title>

    <v-row>
      <v-col cols="12" md="6">
        <gg-loading :loading="!promoTitleLoaded" class="fill-height" type="article">
          <v-card class="app-card fill-height">
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Promo Name:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>{{ promo.promo_name }}</v-list-item-action>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Promo Status:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>{{ heading }}</v-list-item-action>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Payment Amount:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action><b>${{ promoPaymentAmount }}</b></v-list-item-action>
              </v-list-item>

              <v-list-item v-if="promoInvoiceID">
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Invoice ID:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action><b>#{{ promoInvoiceID }}</b></v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        </gg-loading>
      </v-col>
      <v-col cols="12" md="6">
        <gg-loading :loading="!promoTitleLoaded" class="fill-height" type="article">
          <v-card class="app-card fill-height">
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Service:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  {{ promoServiceFormatted }}
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Date Requested:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>{{ promoDate }}</v-list-item-action>
              </v-list-item>
              <v-list-item v-if="promoDateCompleted">
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>Date Completed:</strong>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>{{ promoDateCompleted }}</v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        </gg-loading>
      </v-col>
      <v-col cols="12">
        <gg-loading :loading="!promoTitleLoaded" type="article">
          <v-card class="app-card">
          <v-card-text>
            <h3>
              {{ heading }}
            </h3>
            <component
              :is="bodyComponent"
              :promo="promo"
              :promo_request_id="$route.params.promo_id"
              :payment-falied="paymentFailed"
              @set-status="setStatus"
            />
            <p v-if="completedMsg !== ''" v-html="completedMsg"></p>
          </v-card-text>
        </v-card>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-card class="app-card">
      <v-card-title>
        Error
      </v-card-title>
      <v-card-text>
        {{ error }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PromoPending from './PromoPending'
import PromoRequirePayment from './PromoRequirePayment'
import PromoCompleted from './PromoCompleted'
import PromoEscalated from './PromoEscalated'
import PromoClosed from './PromoClosed'
import { statusNames } from 'Helpers/helpers'
import interval from '@/helpers/interval'

const statusComponents = {
  pending: 'promo-pending',
  requirepayment: 'promo-require-payment',
  paymentfailed: 'promo-require-payment',
  completed: 'promo-completed',
  escalated: 'promo-escalated',
  closed: 'promo-closed',
}

export default {
  name: 'PromoStatus',
  components: {
    PromoPending,
    PromoRequirePayment,
    PromoCompleted,
    PromoEscalated,
    PromoClosed
  },
  data: () => ({
    interval,
    cancelInterval: null,
    stoppedExternally: false,
    promoCompleted: false,
    promo: {
      promo_status: 'pending'
    },
    paymentFailed: false,
    completedMsg: '',
    error: ''
  }),
  computed: {
    ...mapGetters(['services']),
    promoTitleLoaded () {
      return this.promo.hasOwnProperty('result')
    },
    heading () {
      return statusNames[this.promo.promo_status] || 'Undefined Status'
    },
    bodyComponent () {
      return statusComponents[this.promo.promo_status] || { template: `<p class="red--text">Undefined promo status</p>` }
    },
    promoRequestId () {
      return this.$route.params.promo_id
    },
    promoDate () {
      return this.promo.date_generated
    },
    promoDateCompleted () {
      return this.promo.date_completed
    },
    promoPaymentAmount () {
      return this.promo.payment_amount
    },
    promoInvoiceID () {
      return this.promo.invoice
    },
    promoService () {
      return this.services.find(service => service.id === this.promo.promo_service)
    },
    promoServiceFormatted () {
      if (this.promoTitleLoaded) {
        return `${this.promoService.name} - ${this.promoService.domain}`
      } else {
        return 'loading...'
      }
    }
  },
  methods: {
    ...mapActions(['getPromoStatus', 'getPromoView', 'reportError']),
    async getPromoDetails () {
      try {
        this.promo = await this.getPromoView({
          promo_request_id: this.$route.params.promo_id
        })
      } catch (err) {
        this.reportError(err)
      }
    },
    async checkStatus () {
      try {
        const response = await this.getPromoStatus({
          promo_request_id: this.$route.params.promo_id
        })

        if (!this.validateResponse(response)) return

        this.promo.promo_status = response.promo_status

        if (response.promo_status !== 'pending') {
          this.stoppedExternally = true
          this.promoCompleted = true
        }
        if (response.promo_status === 'requirepayment' || response.promo_status === 'paymentfailed') {
          this.$set(this.promo, 'payment_amount', response.payment_amount)
        }
        if (response.promo_status === 'completed') {
          this.completedMsg = response.message_completed
        }
      } catch (err) {
        this.error = err.message
        this.stoppedExternally = true
      }
    },
    async startInterval () {
      this.promo.promo_status = 'pending'
      this.interval(async (iteration, stop) => {
        await this.checkStatus()
        if (this.stoppedExternally) {
          stop()
        }
      }, 15000)
    },
    setStatus (status) {
      this.promo.promo_status = status
      if (status === 'pending') {
        this.startInterval()
      }
    },
    validateResponse (response) {
      const promo_id = this.$route.params.promo_id

      return response.promo_request_id === promo_id
    }
  },
  created () {
    this.getPromoDetails()
  },
  async mounted () {
    await this.checkStatus()
    if (this.promo.promo_status === 'pending') {
      this.startInterval()
    }
  },
  beforeDestroy () {
    this.stoppedExternally = true
  }
}
</script>
